import React from 'react'
import moment from 'moment'
import cn from 'classnames'
import { withTranslation } from 'react-i18next'

import UserAvatarWithStats from 'app/components/UserAvatarWithStats/UserAvatarWithStats'
import Fire from 'app/components/SVGS/Fire'
import {
  ACTION_NAMES,
  PROTRACK_ACTIONS,
  ACTION_NAME_ACHIEVEMENT,
  ACTION_NAME_BADGE_ACHIEVEMENT,
} from 'app/constants/feed'
import { getUserInitials, getUserFullName } from 'helpers/getUserUIData'
import FeedReactions from '../../FeedReactions'

import './styles.scss'
export const bc = 'feed-recent-list-item'

export const FeedRecentListItem = ({
  t,
  identity,
  user,
  timestamp,
  event,
  index,
  handleSetFeedEventLikeOld,
  isNewEvent,
  setReaction,
  reactions,
  updateReaction,
  showReactions,
}) => {
  const identityData = identity.toJS()
  const userData = user || identityData
  const { firstName, lastName, avatar, email } = userData
  const initials = getUserInitials(firstName, lastName, email)
  const fullName = getUserFullName(firstName, lastName)
  const { activityName, name, subject, streak, proTrackProgress } = event
  const userReaction = reactions && reactions.find(item => item.user.id === identityData.id)
  const isShowReactions = showReactions && (name === 'started' || name === 'finished')

  return (
    <div className={cn(bc, { [`${bc}__new`]: isNewEvent })} onAnimationEnd={() => handleSetFeedEventLikeOld(index)}>
      <div className={`${bc}__wrapper`}>
        <div className={`${bc}__image`}>
          <UserAvatarWithStats
            isRecentFeed
            avatar={avatar}
            initials={initials}
            proTrackProgress={proTrackProgress}
            streakCurrent={streak}
            circleProps={{
              cx: 20,
              cy: 20,
              strokeWidth: 2,
              r: 19,
            }}
          />
        </div>
        <div className={`${bc}__user`}>
          <div className={`${bc}__user-name`}>{fullName}</div>
          <div className={`${bc}__user-info`}>
            {name &&
              ACTION_NAMES[name] &&
              ACTION_NAME_ACHIEVEMENT !== name &&
              ACTION_NAME_BADGE_ACHIEVEMENT !== name && (
                <span className={`${bc}__user-status`}>
                  {PROTRACK_ACTIONS.indexOf(name) === -1
                    ? `${t(ACTION_NAMES[name].title)} "${activityName}"`
                    : `${t(ACTION_NAMES[name].title)}`}
                </span>
              )}
            <span className={`${bc}__user-subject`}>
              <span className={`${bc}__user-subject-name`}>{subject}</span>
              {streak ? (
                <span className={`${bc}__user-streak`}>
                  <span className={`${bc}__user-streak-fire`}>
                    <Fire />
                  </span>
                  <span className={`${bc}__user-streak-number`}>+{streak}</span>
                </span>
              ) : null}
            </span>
          </div>
        </div>
        <div className={`${bc}__date`}>{moment(timestamp).fromNow()}</div>
      </div>

      {isShowReactions && (
        <div className={`${bc}__reactions`}>
          <FeedReactions
            reactions={reactions}
            hasReacted={Boolean(userReaction)}
            setReaction={emoji => {
              userReaction ? updateReaction(userReaction, emoji) : setReaction(emoji, event.id, identityData)
            }}
            likeActionEnabled={user.id !== identityData.id}
          />
        </div>
      )}
    </div>
  )
}

export default withTranslation()(FeedRecentListItem)
